import React from "react";

const Footer = () => {
  return (
    <div className="footer">
      <center>
        <p>
          This website is under development.Copyright protected @ShareHub. all
          rights reserved.
        </p>
      </center>
    </div>
  );
};

export default Footer;
